module.exports = __webpack_public_path__ + "static/media/SocialMediaMarketing.7d6e405d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/oldMunafaMart/SocialMediaMarketing.jpg
// module id = 411
// module chunks = 0